var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyProPlanFormMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.25H20C19.04 15.25 18.25 16.04 18.25 17V31C18.25 31.96 19.04 32.75 20 32.75H28C28.96 32.75 29.75 31.96 29.75 31V17C29.75 16.04 28.96 15.25 28 15.25ZM28.25 31C28.25 31.14 28.14 31.25 28 31.25H20C19.86 31.25 19.75 31.14 19.75 31V17C19.75 16.86 19.86 16.75 20 16.75H28C28.14 16.75 28.25 16.86 28.25 17V31ZM25 28C25 28.55 24.55 29 24 29C23.45 29 23 28.55 23 28C23 27.45 23.45 27 24 27C24.55 27 25 27.45 25 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyProPlanFormMobile);
export default __webpack_public_path__ + "static/media/buyProPlanFormMobile.3128ca79a52e26a2798e5dd6d0f714d6.svg";
export { ForwardRef as ReactComponent };